<ng-template [ngIf]="inProgress">
    <div class="center-content">

    <p-knob [(ngModel)]="value" [size]="200"  [showValue]="false"/>
    </div>
    <p class="center-content message">{{ 'sipo.csc-component.callback-component.waiting-message' | translate }}</p>
</ng-template>
<ng-template [ngIf]="!inProgress">
    <div class="message">
        <img src="assets/images/sipo/okimza.svg" width="450px">
        <p>{{ 'sipo.csc-component.callback-component.success-message' | translate }}</p>
        <p>
            <a href="{{ this.url }}" target="_blank">{{ 'sipo.csc-component.callback-component.download' | translate }}</a>
        </p>
        <p>{{ 'sipo.csc-component.callback-component.waiting-thank-you-message' | translate }}</p>


    </div>
</ng-template>

<ng-template [ngIf]="isError">
    <div class="message center-content">
        <img src="assets/images/sipo/nokimza.svg" width="450px">
        <p>{{ 'sipo.csc-component.callback-component.error-occurred-message' | translate }}</p>
        <p>{{ 'sipo.csc-component.callback-component.try-again-message' | translate }}</p>
        <p>{{ 'sipo.csc-component.callback-component.understanding-thank-you-message' | translate }}</p>
    </div>
</ng-template>


